import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import type { WalletBalance } from '@/lib/types';

export function useWalletBalance() {
  return useQuery({
    queryKey: ['/wallets/balance'],
    queryFn: async (): Promise<WalletBalance | null> => {
      const token = apiClient.getToken();
      if (!token) return null;
      
      try {
        const response = await apiClient.get('/wallets/balance');
        if (!response.ok) {
          if (response.status === 401 || response.status === 404) return null;
          return null;
        }
        return response.json();
      } catch {
        return null;
      }
    },
    enabled: !!apiClient.getToken(),
    staleTime: 0,
    gcTime: 0,
  });
}
